import { createAction } from '../../store.model';
import { User } from '../../user/user.model';
import {
    PeriodType,
    ScorecardBoxDto,
    ScorecardDataDto,
} from '../scorecard.model';

import { HistoryPositionNavigate } from './general/history-position-navigate.model';

export enum ActionType {
    SCORECARD_WIDGET__SET_USER = 'SCORECARD_WIDGET__SET_USER',
    SCORECARD_WIDGET__RELOAD = 'SCORECARD_WIDGET__RELOAD',
    SCORECARD_WIDGET__RELOAD_RESULT = 'SCORECARD_WIDGET__RELOAD_RESULT',
    SCORECARD_WIDGET__RELOAD_CANCEL = 'SCORECARD_WIDGET__RELOAD_CANCEL',
    SCORECARD_WIDGET__LIST_DATA = 'SCORECARD_WIDGET__LIST_DATA',
    SCORECARD_WIDGET__LIST_DATA_RESULT = 'SCORECARD_WIDGET__LIST_DATA_RESULT',
    SCORECARD_WIDGET__SELECT_PERIOD_TYPE = 'SCORECARD_WIDGET__SELECT_PERIOD_TYPE',
    SCORECARD_WIDGET__LIST_DATA_CANCEL = 'SCORECARD_WIDGET__LIST_DATA_CANCEL',
    SCORECARD_WIDGET__TOGGLE_SCORECARD_DETAIL = 'SCORECARD_WIDGET__TOGGLE_SCORECARD_DETAIL',
    SCORECARD_WIDGET__NAVIGATE_HISTORY = 'SCORECARD_WIDGET__NAVIGATE_HISTORY',
    SCORECARD_WIDGET__TOGGLE_YOURTEAM_EXPANDED = 'SCORECARD_WIDGET__TOGGLE_YOURTEAM_EXPANDED',
    SCORECARD_WIDGET__RESET = 'SCORECARD_WIDGET__RESET',
}

export interface SetUser {
    user: User;
    authUserId: number;

    /** currently only used to reset the showScorecardDetail flag when the component is instantiated */
    isOnStateConnect: boolean;
}

export const setUser = createAction<ActionType, SetUser>(
    ActionType.SCORECARD_WIDGET__SET_USER,
);

/// ///////

export interface Reload {
    periodTypes?: PeriodType[];
}

export interface ReloadResult extends Reload {
    scorecardBoxes?: ScorecardBoxDto[];
}

export const reload = createAction<ActionType, Reload>(
    ActionType.SCORECARD_WIDGET__RELOAD,
);
export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.SCORECARD_WIDGET__RELOAD_RESULT,
);

/// ///////

export interface ListData {
    scorecardIds: number[];
}

export interface ListDataResult extends ListData {
    scorecardData?: ScorecardDataDto[];
}

export const listData = createAction<ActionType, ListData>(
    ActionType.SCORECARD_WIDGET__LIST_DATA,
);
export const listDataResult = createAction<ActionType, ListDataResult>(
    ActionType.SCORECARD_WIDGET__LIST_DATA_RESULT,
);

/// ///////

export interface SelectPeriodType {
    periodType: PeriodType;
}

export const selectPeriodType = createAction<ActionType, SelectPeriodType>(
    ActionType.SCORECARD_WIDGET__SELECT_PERIOD_TYPE,
);

/// //////

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ToggleScorecardDetail {}

export const toggleScorecardDetail = createAction<
    ActionType,
    ToggleScorecardDetail
>(ActionType.SCORECARD_WIDGET__TOGGLE_SCORECARD_DETAIL);

/// ///////

export interface NavigateHistory {
    historyPosNav: HistoryPositionNavigate;
}

export const navigateHistory = createAction<ActionType, NavigateHistory>(
    ActionType.SCORECARD_WIDGET__NAVIGATE_HISTORY,
);

/// ///////

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ToggleYourTeamExpanded {}

export const toggleYourTeamExpanded = createAction<
    ActionType,
    ToggleYourTeamExpanded
>(ActionType.SCORECARD_WIDGET__TOGGLE_YOURTEAM_EXPANDED);

/// //////

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Reset {}

/** TODO revise. this is temporary means of flushing tabs after auth user has changed */
export const reset = createAction<ActionType, Reset>(
    ActionType.SCORECARD_WIDGET__RESET,
);
